import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const STYLE = {
  ok: { dot: "bg-emerald-500", text: "text-emerald-700", label: "Storage OK" },
  degraded: { dot: "bg-amber-500", text: "text-amber-700", label: "Storage degraded" },
  down: { dot: "bg-red-500", text: "text-red-700", label: "Storage unavailable" },
};

export const StorageHealthBadge = () => {
  const [h, setH] = useState(null);
  useEffect(() => {
    let alive = true;
    const load = () => api.get("/storage/health").then((r) => alive && setH(r.data)).catch(() => alive && setH({ status: "down" }));
    load();
    const id = setInterval(load, 60000);
    return () => { alive = false; clearInterval(id); };
  }, []);
  if (!h) return <span className="inline-flex items-center gap-1.5 text-[11px] text-zinc-400" data-testid="storage-health-loading"><span className="h-2 w-2 animate-pulse rounded-full bg-zinc-300" />Checking storage…</span>;
  const s = STYLE[h.status] || STYLE.down;
  return (
    <span className={`inline-flex items-center gap-1.5 text-[11px] font-medium ${s.text}`} data-testid="storage-health" data-status={h.status}
      title={h.latency_ms != null ? `Response time ${h.latency_ms} ms` : undefined}>
      <span className={`h-2 w-2 rounded-full ${s.dot}`} />{s.label}
      {h.status === "degraded" && <span className="font-normal text-zinc-500">· uploads may be slow</span>}
      {h.status === "down" && <span className="font-normal text-zinc-500">· try again later</span>}
    </span>
  );
};
